<!-- 产品推荐 -->
<template>
  <div class="recommend-container">
    <div class="footer">
      <div class="recommend-classify" v-for="(item,index) in recommendList" :key="index">
        <div class="classify-img">
          <van-divider
            :style="{ color: item.color, borderColor: item.color, padding: '0 16px' }"
          >
            <img class="img" :src="cdnUrl+item.icon" alt="" v-show="item.icon != 'null'">
            <span class="van-multi-ellipsis--l2">{{item.title}}</span>
          </van-divider>
        </div>
        <div class="step-list">
          <div class="item" v-for="(item,index) in item.recommends" :key="index" @click="goProductDetails(item.product_id || '')">
            <div class="top-content">
              <div class="left-cover">
                <img class="cover-img" :src="cdnUrl+item.img_url" alt="">
              </div>
              <div class="right-title">
                <div class="tit van-multi-ellipsis--l3">{{item.title}}</div>
                <div class="btn">
                  <button class="button" v-show="item.product_id">相关产品</button>
                </div>
              </div>
            </div>
            <div class="bottom-ul">
              <div class="li" v-for="(item,index) in item.desc" :key="index">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="recommendList.length == 0">
        <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">
        <p class="hint-text">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        cdnUrl: this.$config.baseUrl.cdnUrl
      }
    },
    props: {
      recommendList: {
        type: Array,
        default: () => []
      }
    },
    created () {

    },
    mounted () {

    },
    methods: {
      goProductDetails (id) {
        console.log(id)
        if (id) {
          // 设置解决方案产品跳转的tab
          window.localStorage.setItem("solutionTabs", this.$parent.$parent.$parent.$parent.tabsActive);
          this.$router.push({
            name: 'productDetails',
            query: {
              id: id
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .recommend-container {
    padding: 0 rem(20);
    .recommend-classify {
      .classify-img {
        width: 85%;
        margin: 0 auto;
        /*height: rem(45);*/
        .img {
          width: rem(23);
          height: rem(23);
          margin-right: rem(8);
        }
        span{
          font-size: rem(15);
          font-weight: bolder;
          text-align: center;
        }
      }
      .step-list {
        .item {
          background: #fff;
          border-radius: 4px;
          padding: rem(17);
          margin-bottom: rem(20);
          box-shadow: 0 0 11px 0 #cfcfcf;
          &:last-child {
            margin-bottom: rem(20);
          }
          .top-content {
            display: flex;
            .left-cover {
              width: rem(140);
              height: rem(92);
              background: #cfcfcf;
              border-radius: 4px;
              .cover-img {
                width: 100%;
                height: 100%;
                border-radius: 4px;
              }
            }
            .right-title {
              flex: 1;
              padding: rem(2) rem(10);
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .tit {
                color: #2C2C2C;
                font-size: rem(13);
                font-weight: bold;
              }
              .btn {
                text-align: right;

                .button {
                  background: $base-color;
                  padding: rem(5) rem(8);
                  outline: none;
                  border: none;
                  font-size: rem(11);
                  color: #fff;
                  border-radius: 4px;
                }
              }
            }
          }

          .bottom-ul {
            margin-top: rem(10);
            .li{
              padding-left: rem(10);
              line-height: rem(20);
              color: #333333;
              font-size: rem(12);
              position: relative;
              &:after{
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                background: #333;
                border-radius: 50%;
                position: absolute;
                top: rem(6);
                left: 0;
              }
            }
          }
        }
      }
    }
    .no-data{
      width: 60%;
      display: block;
      margin: 0 auto;
      margin-top: rem(35);
      text-align: center;
      color: #b1acac;
      font-size: rem(13);
      padding-bottom: rem(10);
      .hint-text{
        margin: rem(10) 0;
      }
    }
  }
</style>
